"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;
Object.defineProperty(exports, "h", {
  enumerable: true,
  get: function get() {
    return _h.h;
  }
});

var _vnode = _interopRequireDefault(require("./vnode"));

var _pixiapi = _interopRequireDefault(require("./pixiapi"));

var is = _interopRequireWildcard(require("./is"));

var _h = require("./h");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function isUndef(s) {
  return s === undefined;
}

function isDef(s) {
  return s !== undefined;
}

function sameVnode(vnode1, vnode2) {
  return vnode1.sel === vnode2.sel && vnode1.texture === vnode2.texture;
}

function isVnode(vnode) {
  return vnode.sel !== undefined;
}

function init(modules, pApi) {
  var api = pApi !== undefined ? pApi : _pixiapi["default"];

  function emptyNodeAt(app) {
    return (0, _vnode["default"])('app', {}, [], app);
  }

  function createRmCb(childElm) {
    return function rmCb() {
      var parent = api.parentNode(childElm);
      api.removeChild(parent, childElm);
    };
  }

  function createElm(vnode) {
    var i;
    var children = vnode.children,
        sel = vnode.sel,
        texture = vnode.texture,
        data = vnode.data;
    var tag = sel;
    var elm = vnode.elm = api.createElement(tag, texture, data);
    api.setDataContent(elm, data);

    if (is.array(children)) {
      for (i = 0; i < children.length; ++i) {
        var ch = children[i];

        if (ch !== null) {
          api.addChild(elm, createElm(ch));
        }
      }
    }

    return vnode.elm;
  }

  function addVnodes(parentElm, before, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];

      if (ch !== null) {
        api.addChildBefore(parentElm, createElm(ch), before);
      }
    }
  }

  function removeVnodes(parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var i = void 0,
          rm = void 0,
          ch = vnodes[startIdx];

      if (ch !== null) {
        if (isDef(ch.sel)) {
          rm = createRmCb(ch.elm);
          rm();
        }
      }
    }
  }

  function updateChildren(parentElm, oldCh, newCh) {
    var oldStartIdx = 0,
        newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var before;

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (oldStartVnode == null) {
        oldStartVnode = oldCh[++oldStartIdx];
      } else if (oldEndVnode == null) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (newStartVnode == null) {
        newStartVnode = newCh[++newStartIdx];
      } else if (newEndVnode == null) {
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else {
        api.addChildBefore(parentElm, createElm(newStartVnode), oldStartVnode.elm);
        newStartVnode = newCh[++newStartIdx];
      }
    }

    if (oldStartIdx <= oldEndIdx || newStartIdx <= newEndIdx) {
      if (oldStartIdx > oldEndIdx) {
        before = newCh[newEndIdx + 1] == null ? undefined : newCh[newEndIdx + 1].elm;
        addVnodes(parentElm, before, newCh, newStartIdx, newEndIdx);
      } else {
        removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
      }
    }
  }

  function patchVnode(oldVnode, vnode) {
    var elm = vnode.elm = oldVnode.elm;
    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (oldVnode === vnode) return;

    if (isDef(oldCh) && isDef(ch)) {
      if (oldCh !== ch) updateChildren(elm, oldCh, ch);
    } else if (isDef(ch)) {
      addVnodes(elm, ch);
    } else if (isDef(oldCh)) {
      removeVnodes(elm, oldCh);
    } else {}

    api.setDataContent(elm, vnode.data);
  }

  return function patch(oldVnode, vnode) {
    var elm;

    if (!isVnode(oldVnode)) {
      oldVnode = emptyNodeAt(oldVnode);
    }

    if (sameVnode(oldVnode, vnode)) {
      patchVnode(oldVnode, vnode);
    } else {
      elm = oldVnode.elm;
      createElm(vnode);
      api.addChild(elm, vnode.elm);
    }

    return vnode;
  };
}

;